import { useSelector, useDispatch } from 'react-redux'
import { setUser, initialState } from 'store/auth/userSlice'
import { setPartner } from 'store/auth/partnerSlice'
import { apiSignIn } from 'services/AuthService'
import { getMyDetails } from 'services/CommonService'
import { onSignInSuccess, onSignOutSuccess } from 'store/auth/sessionSlice'
import appConfig from 'configs/app.config'
import { REDIRECT_URL_KEY } from 'constants/app.constant'
import { useNavigate } from 'react-router-dom'
import useQuery from './useQuery'
import { eywafarm_PREFIX_PATH } from 'constants/route.constant'
import { ADMIN, Content_Expert, Content_Manager, Markerting_User, Report_User, Seed_Data, Seed_Expert } from 'constants/roles.constant'
import { resetAllState } from '../../resetAllState';
import { GetPartnerDetails } from 'store/base/commonSlice'
import { apiGetPartnerContractDetails } from 'services/PartnerService'

function useAuth() {

    const dispatch = useDispatch()

    const navigate = useNavigate()

	const query = useQuery()

    const { token, signedIn } = useSelector((state) => state.auth.session)
	const currentPartner = useSelector(state => state.auth.partner);
	
    const signIn = async (values) => {
        try {
			const resp = await apiSignIn(values)
			navigate('/initial-loading')
			const redirectUrl = values.password
			.indexOf(process.env.REACT_APP_default_password_prefix || 'default') === 0 ? `change-password`: '/dashboard';
			await performSignIn(resp.data.jwt, resp?.data?.partner, dispatch, navigate, redirectUrl);
		} catch (errors) {
			return {
                status: 'failed',
                message: errors?.response?.data?.message || errors.toString()
            }
		}
    }

    const handleSignOut = ()  => {
		dispatch(onSignOutSuccess())
		dispatch(setUser(initialState))
		dispatch(resetAllState());
		signOutRedirect();
		// **JSR,...TODO: Here some redirect Issue.
	}
	const signOutRedirect = () => {
		if(currentPartner && currentPartner.id !== -1) {
			navigate(`/sign-in/${currentPartner.shortName}`)
		}else {
			navigate(appConfig.unAuthenticatedEntryPath)
		}
	}

    const signOut = async () => {
		// await apiSignOut()
		handleSignOut()
	}
    
    return {
        authenticated: token && signedIn,
        signIn,
        signOut
    }
}

const performSignIn = async (jwt, partner, dispatch, navigate, defaultPath) => {

	if(partner) {
		dispatch(setPartner({...partner}))
	}

	dispatch(onSignInSuccess(jwt))

	setTimeout(async ()=> {
		
		const me = await getMyDetails();
		const user = {
			id: me.data.id,
			userName: me.data.username,
			email: me.data.email,
			accountUserName: me.data.name,
			avatarId: me?.data?.avatar?.id,
			...me.data
		};

		const authority = await getUserAuthorities(me.data, partner)
		if (authority) {
			user.authority = authority;
			const url = me?.data?.avatar?.formats?.thumbnail?.url?me?.data?.avatar?.formats?.thumbnail?.url:"/img/logo/eywa-farm-logo_HighRes.png";
			dispatch(setUser({...user, avatar:url}))
			if (partner?.id) {
				try {
					const contract = await apiGetPartnerContractDetails(partner.id)
					const updatedPartner = { ...(partner || {}), contractDetails: contract?.data }
					dispatch(setPartner(updatedPartner))
				} catch (e) {
				}
			}
			if(defaultPath){
				navigate(`${eywafarm_PREFIX_PATH}/${defaultPath}`)
			}else{
				navigate(getAuthenticatedEntryPointForLoggedInuser(user.authority))
			}
				
		}
	}, 1)
}
const getUserAuthorities = async (user, partner) => {
	
	if(partner){
		let partnerId = partner?.id
		return new Promise((resolve, reject) => {
			GetPartnerDetails(
				partnerId,
				(res)=>{
					const authorities = []
					
					authorities.push()
					if(user.tene_partner_user_info == null) {
						authorities.push(Content_Manager)
					}else {
						const eywafarmRoles = user.tene_partner_user_info.tene_partner_roles;
						// Is Admin role?
						if(eywafarmRoles.find(ele => +ele.id === +process.env.REACT_APP_PARTNER_ROLE_partner_admin_id)){
							authorities.push(ADMIN)
						}
						
						// Is Content_Expert role?
						if(eywafarmRoles.find(ele => +ele.id === +process.env.REACT_APP_PARTNER_ROLE_Content_Expert_id) || eywafarmRoles.find(ele => ele.name === Content_Expert)){
							authorities.push(Content_Expert)
						}
							
						// Is Markerting_User role?
						if(eywafarmRoles.find(ele => +ele.id === +process.env.REACT_APP_PARTNER_ROLE_Markerting_User_id) || eywafarmRoles.find(ele => ele.name === Markerting_User)){
							authorities.push(Markerting_User)
						}
							
						// Is Report_User role?
						if(eywafarmRoles.find(ele => +ele.id === +process.env.REACT_APP_PARTNER_ROLE_Report_User_id) || eywafarmRoles.find(ele => ele.name === Report_User)){
							authorities.push(Report_User)
						}

						// Is Seed_Expert role?
						if(eywafarmRoles.find(ele => +ele.id === +process.env.REACT_APP_PARTNER_ROLE_Seed_Expert_id) || eywafarmRoles.find(ele => ele.name === Seed_Expert) || eywafarmRoles.find(ele => ele.name === 'seed_expert')){
							authorities.push(Seed_Expert)
						}

						// Is partner type seed_data?
						let partnerTypes = res?.data?.attributes?.partnertypes?.data?.map(li => li?.id)
						if(partnerTypes?.length){
							if(partnerTypes.includes(+process.env.REACT_APP_PARTNER_TYPE_Seed_Company)){
								authorities.push(Seed_Data)
							}
						}
						
					}
					resolve(authorities);
				},
				(err)=>{
					reject(err)
				}
			)
		});
		
	}
	return Promise.resolve([Content_Manager])
	// **JSR,...TODO: Here Ideally API should return user role as well and
	// We should check if user has Authenticated role or not.
	// For now relaying on fact only content manager and partner users can logs into system.
}
const getAuthenticatedEntryPointForLoggedInuser = (authorities) => {
	if(authorities.find(ele => ele === ADMIN))
		return `${eywafarm_PREFIX_PATH}/usermanagement`;
	else if(authorities.find(ele => ele === Content_Expert) || authorities.find(ele => ele === Content_Manager))
		return `${eywafarm_PREFIX_PATH}/cropcycle`;
	else if(authorities.find(ele => ele === Markerting_User) || authorities.find(ele => ele === Seed_Expert))
		return `${eywafarm_PREFIX_PATH}/seeddata`;
	else if(authorities.find(ele => ele === Report_User))
		return `${eywafarm_PREFIX_PATH}/businessmanagement`;
	else 
		return `/access-denied`;
}


export default useAuth
export { performSignIn }
